// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"71614b15","415":"6eb04385","571":"25bb101f","859":"d3f3912d"}[chunkId] + ".chunk.js";
};